import { create } from 'zustand';

export interface ModalItem<P = unknown> {
    // 고유 식별자
    id: string;
    open: boolean;
    title: string;
    containerClass?: string;
    isCustom?: boolean;
    initContents: InitContentsFn<P>;
}

export type InitContentsFn<P = unknown> = (props?: P) => React.ReactNode;
// 전역 스토어 생성 (zustand)

export interface ModalStore<P = unknown> {
    modals: ModalItem[];

    // 열기
    showModal: (
        // 모달 구성을 담은 매개변수
        modal: {
            id?: string; // 지정하지 않으면 임의 생성
            title?: string;
            containerClass?: string;
            isCustom?: boolean;
            initContents: () => React.ReactNode;
        }
    ) => string; // 모달 id 반환

    // 닫기
    closeModal: (id: string) => void;
    // 닫기(모두)
    closeAll: () => void;
}

export const useModalStore = create<ModalStore>((set) => ({
    modals: [],
    showModal: ({ id, title = '', containerClass, isCustom = false, initContents }) => {
        const newId = id ?? `modal_${Date.now()}_${Math.random()}`;
        const newModal: ModalItem = {
            id: newId,
            open: true,
            title,
            containerClass,
            isCustom,
            initContents,
        };

        set((state) => ({
            modals: [...state.modals, newModal],
        }));

        return newId;
    },

    closeModal: (id: string) => {
        set((state) => ({
            modals: state.modals.filter((m) => m.id !== id),
        }));
    },

    closeAll: () => {
        set({ modals: [] });
    },
}));
